// extracted by mini-css-extract-plugin
export default {"error":"Error404_error__MrzdF","error__text":"Error404_error__text__SK1hj","error__image":"Error404_error__image__-gzG3"};